import React, { useState, useEffect } from "react";
import { Box, Button, Select, MenuItem } from "@mui/material";
import { Route, Routes } from 'react-router-dom'
import { useNavigate } from "react-router";
import {useDispatch, useSelector} from "react-redux"
import { setUserInfo } from "../../redux/slice/user";
import api from "../../API";
import GroupIcon from '@mui/icons-material/Group';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import RuleIcon from '@mui/icons-material/Rule';
import { SearchBackDrop } from "../component/common/SearchBackDrop";
import TzaWorkerCreatePage from "./create/TzaWorkerCreatePage";
import TzaWorkerPDRCreateListPage from "./create/TzaWorkerPDRCreateListPage";
import TzaInstructionListMngPage from "./create/TzaInstructionListMngPage";
import TzaWorkerPRCPage from "./prc/TzaWorkerPRCPage";
import TzaWorkerTransPage from "./trans/TzaWorkerTransPage";
import TzaWorkerISPPage from "./isp/TzaWorkerISPPage";
import TzaWorkerPage from "./TzaWorkerPage";
import TzaInstructionListPage from "./create/TzaInstructionListPage";
import TzaWorkerWikiPage from "./wiki/TzaWorkerWikiPage";
import TzaInstructionCreatePage from "./create/TzaInstructionCreatePage";


const TzaWorkerRouter = (props:any) => {

  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;

  let union_role = auth.user.roles.some((obj:any) => ['TZA_ISP'].includes(obj.role) && ['Y'].includes(obj.type));

  let work_pdf = auth.user.roles.some((obj:any) => ['TZA_ISP'].includes(obj.role) && ['PDF'].includes(obj.use_yn));

  return (
    <Box>
      <Routes>
        {/* <Route path="main" element={<MainPage />} /> */}
        {union_role ? 
          <>
          <Route path="/inst" element={<TzaInstructionCreatePage />} /> 
          <Route path="/create" element={<TzaInstructionListPage />} /> 
          <Route path="/wiki" element={<TzaWorkerWikiPage />} /> 
          </>
          : 
          <Route path="/create" element={<TzaWorkerCreatePage />} />
        }
        {work_pdf &&
          <Route path="/pdf" element={<TzaWorkerPDRCreateListPage />} />
        }
        <Route path="/prc" element={<TzaWorkerPRCPage />} />
        <Route path="/trans" element={<TzaWorkerTransPage />} />
        <Route path="/isp" element={<TzaWorkerISPPage />} />
        <Route path="*" element={<TzaWorkerPage />} />
      </Routes>
    </Box>
  );
};

export default TzaWorkerRouter;
